import React from "react";
import MaterialTable from "material-table";
import tableStyle from "configurations/styles/table";
import { palette } from "configurations/styles/theme";
import { useSnackbar } from "notistack";
import checkInputs from "utils/checkInputs";
import { TextField, makeStyles, FormControl, NativeSelect } from "@material-ui/core";
import { tableIcons } from "./OverrideIcons";
import { codigoOti } from "../../views/facturacion/Forms/typeVoucher"

const useStyles = makeStyles({
  editComponent: {
    paddingRight: "5px"
  }
})

export default function EditTable({
  dataAditional,
  setDataAditional,
  maxRows = 20,
}) {
  const letterColor = palette.primary.main;
  const classes = useStyles();
  const handleSubmit = (data) => {
    let errors = [];

    if (!checkInputs.notNull(data.codigo)) {
      errors.push("Ingrese el codigo del OTI, es necesario.");
    } else if (!checkInputs.isAlphanumeric(data.codigo)) {
      errors.push("Ingrese solo caracteres alafanuméricos.");
    } else if (checkInputs.countLenth(data.codigo) > 2) {
      errors.push("No ingrese más de 2 caracteres.");
    }

    if (!checkInputs.notNull(data.valor)) {
      errors.push("Ingrese el valor, es necesario.");
    } else if (!checkInputs.isDecimal(data.valor)) {
      errors.push("Ingrese solo números");
    }



    errors.forEach((item) => {
      enqueueSnackbar(item, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        autoHideDuration: 10000,
      });
    });
    return errors.length === 0;
  };

  const columns = [
    {
      title: "Código",
      field: "codigo",
      cellStyle: tableStyle.cellTable,
      editComponent: (props) => (
        // <TextField
        //   type="text"
        //   value={props.value}
        //   onChange={(e) => props.onChange(e.target.value)}
        //   variant="standard"
        //   placeholder="Código"
        //   className={classes.editComponent}
        // />
        <FormControl>
          <NativeSelect
            value={props.value}
            onChange={(e) => props.onChange(e.target.value)}
          >
            <option aria-label="None" value="">--Seleccione--</option>
            <option value="01">SUME 911</option>
            <option value="02">Tasa Portabilidad Numérica</option>
            <option value="03">Impuesto sobre seguro</option>
          </NativeSelect>
        </FormControl>
      ),
    },
    {
      title: "Valor",
      field: "valor",
      cellStyle: tableStyle.cellTable,
      editComponent: (props) => (
        <TextField
          type="text"
          value={props.value}
          onChange={(e) => props.onChange(e.target.value)}
          variant="standard"
          placeholder="Valor"
          className={classes.editComponent}
        />
      ),
    },
  ];

  const { enqueueSnackbar } = useSnackbar();

  return (
    <MaterialTable
      title="Otras tasas o impuestos (OTI)"
      columns={columns}
      data={dataAditional.length > 0 ? dataAditional : []}
      localization={{
        header: {
          actions: "",
        },
        body: {
          editRow: {
            deleteText: "¿Está seguro de eliminar la fila ?",
            saveTooltip: "Guardar cambios.",
            cancelTooltip: "Cancelar cambios.",
          },
          addTooltip: "Agregar",
          editTooltip: "Editar fila",
          deleteTooltip: "Eliminar fila",
          emptyDataSourceMessage: "No existen datos",
        },
        pagination: {
          labelRowsSelect: "Filas por página",
          labelDisplayedRows: "{from}-{to} de {count}",
        },
      }}
      options={{
        search: false,
        sorting: false,
        headerStyle: {
          backgroundColor: letterColor,
          color: "#FFFFFF",
          borderStyle: "solid",
          borderColor: letterColor,
          borderWidth: "1px",
          alignItems: "center",
          textAlign: "center",
          padding: "0px",
        },
        rowStyle: {
          borderStyle: "solid",
          borderColor: letterColor,
          borderWidth: "1px 1px ",
          alignContent: "center",
          textAlign: "center",
          paddingRight: "1px",
        },
      }}
      editable={{
        isEditable: (rowData) =>
          typeof rowData.isEditable === "boolean" ? rowData.isEditable : true,
        isDeletable: (rowData) =>
          typeof rowData.isDeletable === "boolean" ? rowData.isDeletable : true,
        onRowAdd: (newData) =>
          new Promise((resolve, reject) => {
            setTimeout(() => {
              if (dataAditional.length < maxRows) {
                if (typeof newData === "object") {
                  const isValid = handleSubmit(newData);
                  if (isValid) {
                    setDataAditional([...dataAditional, newData]);
                    resolve();
                  } else {
                    reject();
                  }
                }
              } else {
                enqueueSnackbar(`Únicamente puede agregar ${maxRows} filas`, {
                  variant: "warning",
                  anchorOrigin: {
                    vertical: "top",
                    horizontal: "right",
                  },
                  autoHideDuration: 4000,
                });
                resolve();
              }
            }, 1000);
          }),
        onRowUpdate: (newData, oldData) =>
          new Promise((resolve, reject) => {
            setTimeout(() => {
              const dataUpdate = [...dataAditional];
              const index = oldData.tableData.id;
              const isValid = handleSubmit(newData);
              if (isValid) {
                dataUpdate[index] = newData;
                setDataAditional([...dataUpdate]);
                resolve();
              } else {
                reject();
              }
            }, 1000);
          }),
        onRowDelete: (oldData) =>
          new Promise((resolve, reject) => {
            setTimeout(() => {
              const dataDelete = [...dataAditional];
              const index = oldData.tableData.id;
              dataDelete.splice(index, 1);
              setDataAditional([...dataDelete]);
              resolve();
            }, 1000);
          }),
      }}
      icons={tableIcons}
    />
  );
}
